module.exports = __webpack_public_path__ + "img/care.5524bdab.png";